module.exports = __webpack_public_path__ + "media/img/logos/legi-37d5112dc28aeb6ea079d79307a29cf3.svg";